import { AxiosResponse } from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ACTION_ADD, ACTION_FETCH } from './const';
import {
  Params,
  Providers,
  Review,
  Reviews,
  ReviewsFetched,
  ReviewSaved,
  State,
  Statuses,
} from './types';

const { ERROR, READY, STADY, WAITING } = Statuses;

const SET_STATUS = 'setStatus';
const ADD_REVIEW = 'addReview';
const SET_REVIEWS = 'setReviews';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageOrganizationReviewStore extends VuexModule<State, any> {
    // State
    status: Statuses = READY;
    reviews: Reviews = [];

    // Mutations
    @Mutation
    [SET_STATUS](status: Statuses) {
      this.status = status;
    }

    @Mutation
    [ADD_REVIEW](review: ReviewSaved) {
      this.reviews.unshift(review);
    }

    @Mutation
    [SET_REVIEWS](reviews: Reviews) {
      this.reviews = reviews;
    }

    // Actions
    @Action
    async [ACTION_FETCH](params: Params) {
      const { commit } = this.context;
      if (this.status === WAITING) return;

      commit(SET_STATUS, WAITING);
      try {
        const { data } = await $api.get<AxiosResponse<ReviewsFetched>>('organization/reviews/get', { params });
        const reviews = data.data
          .map(({ date, fio, text, rate }): ReviewSaved => ({
            fio,
            text,
            date: new Date(date),
            rate: typeof rate === 'number' ? rate : parseInt(rate, 10),
          }))
          .sort((a, b) => Number(a.date) - Number(b.date));

        commit(SET_REVIEWS, reviews);
        commit(SET_STATUS, READY);
      } catch (e) {
        // Обрабатываем ошибку
        commit(SET_STATUS, ERROR);
      }
    }

    @Action
    async [ACTION_ADD](review: Review, immediately: boolean = false): Promise<void> {
      const { commit, dispatch } = this.context;
      commit(SET_STATUS, WAITING);

      if (immediately) {
        const adding: ReviewSaved = { ...review, date: new Date() };
        commit(ADD_REVIEW, adding);
      }

      try {
        await $api.post<AxiosResponse<ReviewSaved>>('organization/reviews/add', review);
        commit(SET_STATUS, STADY);
        await dispatch(ACTION_FETCH);
      } catch ({ response }) {
        // Обрабатываем ошибку
        commit(SET_STATUS, READY);
        const error = response && response.data && response.data.errors;
        throw error;
      }
    }
  }

  return PageOrganizationReviewStore;
}

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/reviews/store.ts